/*
 * @Author: your name
 * @Date: 2020-11-19 15:20:38
 * @LastEditTime: 2021-04-06 16:41:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /v-intersection/src/main.js
 */
import Vue from 'vue'
import App from './App.vue'


Vue.config.productionTip = false

// plugins------------------------------
///Clipboard
import Clipboard from 'v-clipboard'
Vue.use(Clipboard)


    
    




///Toast
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
 
const options = {
   icon:true
};
Vue.use(Toast, options);




///VueHighlightJS
import VueHighlightJS from 'vue-highlightjs'
Vue.use(VueHighlightJS)

import intersection from "v-intersection";
Vue.use(intersection)
// -----------------------------------




new Vue({
  render: h => h(App)
}).$mount('#app')
